import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, RequireAuth } from "@/hooks/useAuth";
import Login from "@/pages/Login";
import Viewer from "@/pages/Viewer";
import SuperAdmin from "@/pages/SuperAdmin";
import CompanyAdmin from "@/pages/CompanyAdmin";
import OrdersList from "@/pages/OrdersList";
import OrderNew from "@/pages/OrderNew";
import OrderDetail from "@/pages/OrderDetail";
import ProductionQueue from "@/pages/ProductionQueue";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/" element={<RequireAuth><Viewer /></RequireAuth>} />
            <Route path="/ordens" element={<RequireAuth><OrdersList /></RequireAuth>} />
            <Route path="/ordens/nova" element={<RequireAuth><OrderNew /></RequireAuth>} />
            <Route path="/ordens/:id" element={<RequireAuth><OrderDetail /></RequireAuth>} />
            <Route path="/producao" element={<RequireAuth><ProductionQueue /></RequireAuth>} />
            <Route
              path="/admin"
              element={
                <RequireAuth roles={["super_admin"]}>
                  <SuperAdmin />
                </RequireAuth>
              }
            />
            <Route
              path="/empresa"
              element={
                <RequireAuth roles={["company_admin"]}>
                  <CompanyAdmin />
                </RequireAuth>
              }
            />
          </Routes>
        </AuthProvider>
      </BrowserRouter>
      <Toaster position="bottom-right" />
    </div>
  );
}

export default App;
